export default __webpack_public_path__ + "static/media/avatar-person.64c66a52.svg";